import { useRef } from 'react'
import { Platform, Vibration } from 'react-native'
import { useGameState } from '../../GameContainer/useGameState'
import { playSound } from '../../../utils/audioService'
import { useStore } from '@/models'

const isWeb = Platform.OS === 'web'
const ENABLE_VIBRATION = !isWeb

export const useVibrationAndSounds = ({ remaining }: { remaining: number }) => {
  const {
    permissions: { isSoundEnabled }
  } = useStore()

  const { isMyTurn } = useGameState()

  const hasVibrated = useRef(false)
  const hasPlayedMyTurnSound = useRef(false)
  const remainingSeconds = Math.ceil(remaining / 1000)

  if (isMyTurn && isSoundEnabled && !hasVibrated.current && remainingSeconds <= 5) {
    ENABLE_VIBRATION && Vibration.vibrate(1000)
    hasVibrated.current = true
  } else if (remainingSeconds > 5 && hasVibrated.current) {
    hasVibrated.current = false
  }

  if (isMyTurn && isSoundEnabled && !hasPlayedMyTurnSound.current) {
    ENABLE_VIBRATION && Vibration.vibrate(1000)
    playSound('yourTurn')
    hasPlayedMyTurnSound.current = true
  } else if (!isMyTurn && hasPlayedMyTurnSound.current) {
    hasPlayedMyTurnSound.current = false
  }
}
